import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { InputContainer, KeyValuePairs, Checkbox } from 'components/ideal-core-ui'
import s from './TableViewModal.scss'

const TableViewModal = ({
  toggleTableViewModal,
  showTableViewModal,
  saveViewAsList,
  setTableViewTitle,
  setIsPublic,
  tableViewTitle,
  isPublic
}) => {
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showTableViewModal}
        toggle={toggleTableViewModal}
        size="md"
      >
        <ModalHeader toggle={toggleTableViewModal} className={s.modalHeader}>
          Save List
        </ModalHeader>
        <ModalBody>
          <KeyValuePairs
            pairs={[
              {
                key: 'View Title',
                value: (
                  <>
                    <InputContainer
                      type="text"
                      text={tableViewTitle}
                      placeholder="View Title"
                      cb={value => setTableViewTitle(value)}
                    />
                    <Checkbox
                      isChecked={isPublic}
                      className={s.isPublic}
                      triggerCheckbox={value => setIsPublic(value.target.checked)}
                    />
                    <span className={s.label}>Make list public</span>
                  </>
                )
              }
            ]}
          />
        </ModalBody>
        <ModalFooter>
          <Button disabled={!tableViewTitle} className={s.saveBtn} onClick={saveViewAsList}>
            Save
          </Button>
          <Button color="secondary" onClick={toggleTableViewModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default TableViewModal
